"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonCreateChannel = exports.buttonOpenDiagram = exports.buttonCalculateMonitoringTaskLimit = exports.buttonCreateMonitoringTaskLimit = exports.buttonDeleteMonitoringTaskLimits = exports.buttonDeactivateMonitoringTasks = exports.buttonActivateMonitoringTasks = exports.buttonCreateMonitoringTask = exports.buttonDeleteMonitoringTasks = exports.buttonDeactivateCharacteristicMonitoringTasks = exports.buttonActivateCharacteristicMonitoringTasks = exports.buttonCreateCharacteristicMonitoringTask = exports.buttonDeleteCharacteristicMonitoringTasks = exports.buttonUpdateNotificationRanges = exports.buttonCreateNotificationRange = exports.buttonDeleteNotificationRange = exports.buttonDeactivateNotificationActionTemporary = exports.buttonDeactivateNotificationAction = exports.buttonActivateNotificationAction = exports.buttonDeleteNotificationAction = exports.buttonCreateNotificationAction = exports.buttonDeactivateNotification = exports.buttonActivateNotification = exports.buttonRemoveActionsFromNotifications = exports.buttonAddActionsToNotifications = exports.buttonDeleteNotification = exports.buttonCreateNotification = exports.buttonNotificationWizard = exports.buttonRemoveGlobalUsers = exports.buttonRemoveUsersFromProject = exports.buttonCreateRole = exports.buttonCreateUser = exports.buttonMoveUsersToRole = exports.buttonAddUser = exports.buttonCreateAdmin = exports.buttonAddAdmin = exports.buttonRemoveActions = exports.buttonCreateAction = exports.buttonCloseAllCards = exports.buttonSaveProjectType = exports.buttonExportProject = exports.buttonImportProject = exports.buttonDuplicateProject = exports.buttonCreateGrafanaDashboard = exports.buttonSaveAdvancedProjectSettings = exports.buttonDisableProject = exports.buttonEnableProject = exports.buttonCreateProjectGroup = exports.buttonSaveProjectSettings = exports.buttonCreateProject = void 0;
exports.buttonAddNewElementFieldType = exports.buttonAddNewElementType = exports.buttonAddNewProjectType = exports.buttonCreateTranslation = exports.buttonCreateSystemSetting = exports.buttonRemoveReportTemplates = exports.buttonDuplicateReportTemplate = exports.buttonCreateReportTemplate = exports.buttonRemoveReports = exports.buttonDuplicateReport = exports.buttonCreateReport = exports.buttonDeleteOperatingStateConditions = exports.buttonCreateOperatingStateCondition = exports.buttonDeleteOperatingStates = exports.buttonCreateOperatingState = exports.buttonControlDevice = exports.buttonDeactivateControlDevice = exports.buttonActivateControlDevice = exports.buttonDeleteControlDevice = exports.buttonCreateControlDevice = exports.buttonCreateVirtualChannel = exports.buttonCreateMetrologyFromCSV = exports.buttonCreateMetrology = exports.buttonHideLocation = exports.buttonShowLocation = exports.buttonDeleteLocation = exports.buttonCreateLocation = exports.buttonDeleteMeasuringManagers = exports.buttonCreateMeasuringManager = exports.buttonHideMeasuringDevice = exports.buttonShowMeasuringDevice = exports.buttonDeleteMeasuringDevice = exports.buttonCreateMeasuringDevice = exports.buttonDuplicateMeasuringDevice = exports.buttonHideSensor = exports.buttonShowSensor = exports.buttonDeactivateSensor = exports.buttonActivateSensor = exports.buttonChangeLocation = exports.buttonDeleteSensor = exports.buttonCreateSensor = exports.buttonCreateGrafanaPanel = exports.buttonShowChannelIds = exports.buttonHideChannel = exports.buttonShowChannel = exports.buttonDeactivateChannel = exports.buttonActivateChannel = exports.buttonAddDataLink = exports.buttonChangeTimezone = exports.buttonDeleteChannel = void 0;
exports.buttonShowMap = exports.buttonCSVImportData = exports.buttonCSVImport = exports.makeButtonItem = exports.buttonCopyNumbers = exports.buttonArchivedFiltered = exports.buttonAddNewInspection = exports.buttonAddNewPlant = exports.buttonCloseDataTable = exports.buttonAddNewInspectionTaskType = exports.buttonAddNewCustomerType = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
/** Project Management *****************************************************************/
exports.buttonCreateProject = {
    label: 'btn_projM_createProject',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
    submit: 'projectForm'
};
exports.buttonSaveProjectSettings = {
    label: 'save',
    className: '',
    icon: free_regular_svg_icons_1.faFloppyDisk,
    submit: 'projectForm'
};
exports.buttonCreateProjectGroup = {
    label: 'btn_projM_createProjectGroup',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
    submit: 'true'
};
exports.buttonEnableProject = {
    label: 'btn_projM_enable',
    className: '',
    icon: free_solid_svg_icons_1.faLockOpen,
};
exports.buttonDisableProject = {
    label: 'btn_projM_disable',
    className: '',
    icon: free_solid_svg_icons_1.faLock,
};
exports.buttonSaveAdvancedProjectSettings = {
    label: 'save',
    className: '',
    icon: free_regular_svg_icons_1.faFloppyDisk,
    submit: 'projectForm'
};
exports.buttonCreateGrafanaDashboard = {
    label: 'userMgmt_addGrafanaDashboard',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDuplicateProject = {
    label: 'btn_duplicateProject',
    className: '',
    icon: free_regular_svg_icons_1.faClone,
};
exports.buttonImportProject = {
    label: 'projectManagement:buttons.importProject',
    className: '',
    icon: free_solid_svg_icons_1.faFileImport,
};
exports.buttonExportProject = {
    label: 'projectManagement:buttons.exportProject',
    className: '',
    icon: free_solid_svg_icons_1.faFileExport,
};
exports.buttonSaveProjectType = {
    label: 'save',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonCloseAllCards = {
    label: 'close_cards',
    className: 'mr-2',
    icon: free_solid_svg_icons_1.faTimes,
};
/** User Management *****************************************************************/
exports.buttonCreateAction = {
    label: 'userManagement:buttons.createAction',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonRemoveActions = {
    label: 'userManagement:buttons.deleteActions',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonAddAdmin = {
    label: 'btn_userM_addAdmin',
    className: '',
    icon: free_solid_svg_icons_1.faUsersRectangle,
};
exports.buttonCreateAdmin = {
    label: 'btn_userM_createAdmin',
    className: '',
    icon: free_solid_svg_icons_1.faUserPlus,
};
exports.buttonAddUser = {
    label: 'btn_userM_addUser',
    className: '',
    icon: free_solid_svg_icons_1.faUsersRectangle,
};
exports.buttonMoveUsersToRole = {
    label: 'btn_userM_moveUsersToRole',
    className: '',
    icon: free_solid_svg_icons_1.faUserTag,
};
exports.buttonCreateUser = {
    label: 'btn_userM_createUser',
    className: '',
    icon: free_solid_svg_icons_1.faUserPlus,
};
exports.buttonCreateRole = {
    label: 'btn_userM_createRole',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonRemoveUsersFromProject = {
    label: 'btn_userM_removeUsers',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonRemoveGlobalUsers = {
    label: 'btn_userM_removeGlobalUsers',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
/** Notification Management *****************************************************************/
exports.buttonNotificationWizard = {
    label: 'alarmManagement:buttons.notificationWizard',
    className: '',
    icon: free_solid_svg_icons_1.faHatWizard, // pi-bolt
};
exports.buttonCreateNotification = {
    label: 'alarmManagement:buttons.createNotification',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteNotification = {
    label: 'alarmManagement:buttons.deleteNotifications',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonAddActionsToNotifications = {
    label: 'alarmManagement:buttons.addActionsToNotifications',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonRemoveActionsFromNotifications = {
    label: 'alarmManagement:buttons.removeActionsFromNotifications',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonActivateNotification = {
    label: 'alarmManagement:buttons.activateNotification',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateNotification = {
    label: 'alarmManagement:buttons.deactivateNotification',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
// +++ Notification Action +++
exports.buttonCreateNotificationAction = {
    label: 'alarmManagement:buttons.createNotificationAction',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteNotificationAction = {
    label: 'alarmManagement:buttons.deleteNotificationAction',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonActivateNotificationAction = {
    label: 'alarmManagement:buttons.activateNotificationAction',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateNotificationAction = {
    label: 'alarmManagement:buttons.deactivateNotificationAction',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
exports.buttonDeactivateNotificationActionTemporary = {
    label: 'alarmManagement:buttons.deactivateNotificationActionTemporary',
    className: '',
    icon: free_solid_svg_icons_1.faStopwatch,
};
// +++ Notification Ranges +++
exports.buttonDeleteNotificationRange = {
    label: 'alarmManagement:buttons.deleteNotificationRange',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateNotificationRange = {
    label: 'alarmManagement:buttons.createNotificationRange',
    className: '',
    icon: free_solid_svg_icons_1.faPlus
};
exports.buttonUpdateNotificationRanges = {
    label: 'alarmManagement:buttons.updateNotificationRanges',
    className: '',
    icon: free_solid_svg_icons_1.faPencil
};
// +++ Characteristic Monitoring Tasks +++
exports.buttonDeleteCharacteristicMonitoringTasks = {
    label: 'alarmManagement:buttons.deleteCharacteristicMonitoringTasks',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateCharacteristicMonitoringTask = {
    label: 'alarmManagement:buttons.createCharacteristicMonitoringTask',
    className: '',
    icon: free_solid_svg_icons_1.faPlus
};
exports.buttonActivateCharacteristicMonitoringTasks = {
    label: 'alarmManagement:buttons.activateCharacteristicMonitoringTasks',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateCharacteristicMonitoringTasks = {
    label: 'alarmManagement:buttons.deactivateCharacteristicMonitoringTasks',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
// +++ Monitoring Tasks +++
exports.buttonDeleteMonitoringTasks = {
    label: 'alarmManagement:buttons.deleteMonitoringTasks',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateMonitoringTask = {
    label: 'alarmManagement:buttons.createMonitoringTask',
    className: '',
    icon: free_solid_svg_icons_1.faPlus
};
exports.buttonActivateMonitoringTasks = {
    label: 'alarmManagement:buttons.activateMonitoringTasks',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateMonitoringTasks = {
    label: 'alarmManagement:buttons.deactivateMonitoringTasks',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
// +++ Monitoring Task Limits +++
exports.buttonDeleteMonitoringTaskLimits = {
    label: 'alarmManagement:buttons.deleteMonitoringTaskLimits',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateMonitoringTaskLimit = {
    label: 'alarmManagement:buttons.createMonitoringTaskLimit',
    className: '',
    icon: free_solid_svg_icons_1.faPlus
};
exports.buttonCalculateMonitoringTaskLimit = {
    label: 'alarmManagement:buttons.calculateMonitoringTaskLimit',
    className: '',
    icon: free_solid_svg_icons_1.faCalculator,
};
exports.buttonOpenDiagram = {
    label: 'alarmManagement:buttons.openDiagram',
    className: '',
    icon: free_solid_svg_icons_1.faMagnifyingGlassChart
};
/** Measurement Management *****************************************************************/
// ---------------------------------------------------------------------------------------------------------------------
// Channel
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonCreateChannel = {
    label: 'metrologyManagement:buttons.createChannel',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteChannel = {
    label: 'metrologyManagement:buttons.deleteChannel',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonChangeTimezone = {
    label: 'metrologyManagement:buttons.changeTimezone',
    className: '',
    icon: free_solid_svg_icons_1.faClock,
};
exports.buttonAddDataLink = {
    label: 'metrologyManagement:buttons.AddDataLink',
    className: '',
    icon: free_solid_svg_icons_1.faLink,
};
exports.buttonActivateChannel = {
    label: 'metrologyManagement:buttons.activateChannel',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateChannel = {
    label: 'metrologyManagement:buttons.deactivateChannel',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
exports.buttonShowChannel = {
    label: 'metrologyManagement:buttons.showChannel',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonHideChannel = {
    label: 'metrologyManagement:buttons.hideChannel',
    className: '',
    icon: free_solid_svg_icons_1.faEyeSlash,
};
exports.buttonShowChannelIds = {
    label: 'metrologyManagement:buttons.showChannelIds',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonCreateGrafanaPanel = {
    label: 'metrologyManagement:buttons.createGrafanaPanel',
    className: '',
    icon: free_solid_svg_icons_1.faDashboard,
};
// ---------------------------------------------------------------------------------------------------------------------
// Sensor
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonCreateSensor = {
    label: 'metrologyManagement:buttons.createSensor',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteSensor = {
    label: 'metrologyManagement:buttons.deleteSensor',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonChangeLocation = {
    label: 'metrologyManagement:buttons.changeLocation',
    className: '',
    icon: free_solid_svg_icons_1.faSearchLocation,
};
exports.buttonActivateSensor = {
    label: 'metrologyManagement:buttons.activateSensor',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateSensor = {
    label: 'metrologyManagement:buttons.deactivateSensor',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
exports.buttonShowSensor = {
    label: 'metrologyManagement:buttons.showSensor',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonHideSensor = {
    label: 'metrologyManagement:buttons.hideSensor',
    className: '',
    icon: free_solid_svg_icons_1.faEyeSlash,
};
// ---------------------------------------------------------------------------------------------------------------------
// MeasuringDevice
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonDuplicateMeasuringDevice = {
    label: 'metrologyManagement:buttons.duplicateMeasuringDevice',
    className: '',
    icon: free_solid_svg_icons_1.faCopy,
};
exports.buttonCreateMeasuringDevice = {
    label: 'metrologyManagement:buttons.createMeasuringDevice',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteMeasuringDevice = {
    label: 'metrologyManagement:buttons.deleteMeasuringDevice',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonShowMeasuringDevice = {
    label: 'metrologyManagement:buttons.showMeasuringDevice',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonHideMeasuringDevice = {
    label: 'metrologyManagement:buttons.hideMeasuringDevice',
    className: '',
    icon: free_solid_svg_icons_1.faEyeSlash,
};
exports.buttonCreateMeasuringManager = {
    label: 'metrologyManagement:buttons.createMeasuringManager',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteMeasuringManagers = {
    label: 'metrologyManagement:buttons.deleteMeasuringManagers',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
// ---------------------------------------------------------------------------------------------------------------------
// Location
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonCreateLocation = {
    label: 'locations:buttons.createLocation',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteLocation = {
    label: 'locations:buttons.deleteLocation',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonShowLocation = {
    label: 'locations:buttons.showLocation',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonHideLocation = {
    label: 'locations:buttons.hideLocation',
    className: '',
    icon: free_solid_svg_icons_1.faEyeSlash,
};
exports.buttonCreateMetrology = {
    label: 'metrologyManagement:buttons.metrologyWizard',
    className: '',
    icon: free_solid_svg_icons_1.faHatWizard,
};
exports.buttonCreateMetrologyFromCSV = {
    label: 'metrologyManagement:buttons.metrologyWizardFromCSV',
    className: '',
    icon: free_solid_svg_icons_1.faHatWizard,
};
exports.buttonCreateVirtualChannel = {
    label: 'metrologyManagement:buttons.createVirtualChannel',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
// ---------------------------------------------------------------------------------------------------------------------
// ControlDevice
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonCreateControlDevice = {
    label: 'metrologyManagement:buttons.createControlDevice',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteControlDevice = {
    label: 'metrologyManagement:buttons.deleteControlDevice',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonActivateControlDevice = {
    label: 'metrologyManagement:buttons.activateControlDevice',
    className: '',
    icon: free_solid_svg_icons_1.faCheck,
};
exports.buttonDeactivateControlDevice = {
    label: 'metrologyManagement:buttons.deactivateControlDevice',
    className: '',
    icon: free_solid_svg_icons_1.faTimes,
};
exports.buttonControlDevice = {
    label: 'metrologyManagement:buttons.controlDevices',
    className: '',
    icon: free_solid_svg_icons_1.faGamepad,
};
// ---------------------------------------------------------------------------------------------------------------------
// OperatingState
// ---------------------------------------------------------------------------------------------------------------------
exports.buttonCreateOperatingState = {
    label: 'metrologyManagement:buttons.createOperatingState',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteOperatingStates = {
    label: 'metrologyManagement:buttons.deleteOperatingStates',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateOperatingStateCondition = {
    label: 'metrologyManagement:buttons.createOperatingStateCondition',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDeleteOperatingStateConditions = {
    label: 'metrologyManagement:buttons.deleteOperatingStateConditions',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
/** Reporting *****************************************************************/
exports.buttonCreateReport = {
    label: 'reportingManagement:buttons.createReport',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDuplicateReport = {
    label: 'reportingManagement:buttons.duplicateReport',
    className: '',
    icon: free_solid_svg_icons_1.faCopy,
};
exports.buttonRemoveReports = {
    label: 'reportingManagement:buttons.deleteReports',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
exports.buttonCreateReportTemplate = {
    label: 'reportingManagement:buttons.createReportTemplate',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonDuplicateReportTemplate = {
    label: 'reportingManagement:buttons.duplicateReportTemplate',
    className: '',
    icon: free_solid_svg_icons_1.faCopy,
};
exports.buttonRemoveReportTemplates = {
    label: 'reportingManagement:buttons.deleteReportTemplates',
    className: 'p-button-danger',
    icon: free_solid_svg_icons_1.faTrashCan,
};
/** System *****************************************************************/
exports.buttonCreateSystemSetting = {
    label: 'btn_sysM_createSysSett',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
/** Translation *****************************************************************/
exports.buttonCreateTranslation = {
    label: 'btn_langM_createTranslation',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
/** Type management [customer_type] *****************************************************************/
exports.buttonAddNewProjectType = {
    label: 'project_type_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonAddNewElementType = {
    label: 'element_type_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonAddNewElementFieldType = {
    label: 'element_field_type_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonAddNewCustomerType = {
    label: 'customer_type_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonAddNewInspectionTaskType = {
    label: 'inspection_task_type_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonCloseDataTable = {
    label: 'close_dataTable',
    className: 'mr-2',
    icon: free_solid_svg_icons_1.faTimes,
};
/** Units *****************************************************************/
exports.buttonAddNewPlant = {
    label: 'units_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
/** Orders *****************************************************************/
exports.buttonAddNewInspection = {
    label: 'inspection_new',
    className: '',
    icon: free_solid_svg_icons_1.faPlus,
};
exports.buttonArchivedFiltered = {
    label: 'inspection_archive_filtered',
    className: '',
    icon: free_solid_svg_icons_1.faInbox,
};
exports.buttonCopyNumbers = {
    label: 'inspection_copy_numbers',
    className: '',
    icon: free_solid_svg_icons_1.faCopy,
};
function makeButtonItem(item, t, onClick, visible = true, disabled = false) {
    const tmpItem = JSON.parse(JSON.stringify(item));
    tmpItem.onClick = onClick;
    tmpItem.label = t(item.label);
    tmpItem.visible = visible;
    tmpItem.disabled = disabled;
    return tmpItem;
}
exports.makeButtonItem = makeButtonItem;
exports.buttonCSVImport = {
    label: 'globalData:global.csvimport',
    className: '',
    icon: free_solid_svg_icons_1.faFileUpload,
};
exports.buttonCSVImportData = {
    label: 'globalData:global.csvimportdata',
    className: '',
    icon: free_solid_svg_icons_1.faEye,
};
exports.buttonShowMap = {
    label: 'tabs.geoMap',
    className: 'p-button',
    icon: free_solid_svg_icons_1.faMap
};
